// ke-hero — shifting slides with parked-offset animation (same pattern as ke-announcement-bar)
class KeHero extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.ke-hero__slide'));
    this.current = Math.max(0, this.slides.findIndex((s) => s.classList.contains('is-active')));
    this.speed = (parseInt(this.dataset.speed, 10) || 6) * 1000;
    this.transitionMs = (parseFloat(getComputedStyle(this).getPropertyValue('--ke-hero-transition')) || 0.7) * 1000 + 50;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.autoplay = this.dataset.autoplay === 'true' && !this.reducedMotion;

    const rtl = this.dataset.direction !== 'ltr';
    const horizontal = this.dataset.axis !== 'vertical';
    this.enterFrom = horizontal ? (rtl ? 'right' : 'left') : (rtl ? 'bottom' : 'top');
    this.exitTo = horizontal ? (rtl ? 'left' : 'right') : (rtl ? 'top' : 'bottom');
    // Reverse mapping for the prev arrow
    this.enterFromRev = this.exitTo;
    this.exitToRev = this.enterFrom;

    this.parkInactive();

    const prev = this.querySelector('.ke-hero__arrow--prev');
    const next = this.querySelector('.ke-hero__arrow--next');
    if (prev) prev.addEventListener('click', () => { this.go(-1); this.restart(); });
    if (next) next.addEventListener('click', () => { this.go(1); this.restart(); });

    if (this.autoplay && this.slides.length > 1) {
      this.start();
      this.addEventListener('mouseenter', () => clearInterval(this.timer));
      this.addEventListener('mouseleave', () => this.start());
    }

    this.onBlockSelect = (event) => {
      const slide = event.target && event.target.closest && event.target.closest('.ke-hero__slide');
      if (!slide || !this.contains(slide)) return;
      clearInterval(this.timer);
      this.current = this.slides.indexOf(slide);
      this.slides.forEach((s) => {
        s.classList.remove('is-active', 'is-leaving');
        delete s.dataset.exit;
        delete s.dataset.enter;
      });
      slide.classList.add('is-active');
      this.parkInactive();
    };
    this.onBlockDeselect = () => { if (this.autoplay && this.slides.length > 1) this.start(); };
    document.addEventListener('shopify:block:select', this.onBlockSelect);
    document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
    if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
    if (this.onBlockDeselect) document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
  }

  start() {
    clearInterval(this.timer);
    this.timer = setInterval(() => this.go(1), this.speed);
  }
  restart() { if (this.autoplay && this.slides.length > 1) this.start(); }

  parkInactive() {
    this.slides.forEach((s, i) => {
      if (i !== this.current && !s.classList.contains('is-leaving')) s.dataset.enter = this.enterFrom;
    });
  }

  go(dir) {
    if (this.slides.length < 2) return;
    const enterFrom = dir > 0 ? this.enterFrom : this.enterFromRev;
    const exitTo = dir > 0 ? this.exitTo : this.exitToRev;

    const oldSlide = this.slides[this.current];
    this.current = (this.current + dir + this.slides.length) % this.slides.length;
    const newSlide = this.slides[this.current];

    // Ensure the incoming slide is parked on the correct side with a committed style
    if (newSlide.dataset.enter !== enterFrom || newSlide.classList.contains('is-leaving')) {
      newSlide.classList.remove('is-leaving');
      delete newSlide.dataset.exit;
      newSlide.dataset.enter = enterFrom;
      void newSlide.offsetWidth;
    }

    oldSlide.classList.remove('is-active');
    oldSlide.classList.add('is-leaving');
    oldSlide.dataset.exit = exitTo;

    delete newSlide.dataset.enter;
    newSlide.classList.add('is-active');

    setTimeout(() => {
      oldSlide.classList.remove('is-leaving');
      delete oldSlide.dataset.exit;
      if (this.slides[this.current] !== oldSlide) oldSlide.dataset.enter = this.enterFrom;
    }, this.transitionMs);

    // Pause videos on hidden slides, play the active one
    this.slides.forEach((s) => {
      const v = s.querySelector('video');
      if (!v) return;
      if (s === newSlide) { v.play && v.play().catch(() => {}); }
      else { v.pause && v.pause(); }
    });
  }
}
customElements.define('ke-hero', KeHero);
